import {combineReducers} from 'redux';

import {SET_IS_LOADING, OPEN_CLOSE_FILTER_PANEL_MOBILE} from '../actions/page';

const isLoading = (state = false, {type, payload}) => {
    let nextState = state;

    if (type === SET_IS_LOADING) {
        nextState = payload;
    }
    return nextState;
};

const isFilterPanelMobileOpen = (state = false, {type, payload}) => {
    let nextState = state;

    if (type === OPEN_CLOSE_FILTER_PANEL_MOBILE) {
        nextState = payload;
    }

    return nextState;
};

export default combineReducers({
    isFilterPanelMobileOpen,
    isLoading,
    publicId: (state = '') => state,
    sessionId: (state = '') => state,
    guestId: (state = '') => state,
    isBotRequest: (state = false) => state,
    countryCode: (state = '') => state,
    googleMapsLanguage: (state = '') => state,
    httpReferer: (state = '') => state,
    domain: (state = '') => state,
    featureFlags: (state = {}) => state,
    experiments: (state = {}) => state,
    serverUrl: (state = '') => state,
    gaSettings: (state = {}) => state,
    userEmail: (state = '') => state,
});
